import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'

const baseApiUrl = process.env.LISTINGS_URL_API ?? ''

class ListingsBasicApi extends BasicAPI {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}

export const listingsBasicApi = new ListingsBasicApi()
